import { ComponentPropsWithRef } from "react";

export const LikeIcon = (props: ComponentPropsWithRef<"svg">) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M21.5449 34.9336C21.3514 35.1371 21.3514 35.4679 21.5449 35.6714L23.509 37.7376C23.7808 38.0235 24.2192 38.0235 24.491 37.7376L34.3859 27.3293L37.6356 23.9107C40.7881 20.5954 40.7881 15.2014 37.6356 11.8861C34.4851 8.57182 29.3576 8.57182 26.2071 11.8861L24 14.2111L21.7939 11.8861C18.6434 8.57182 13.5159 8.57078 10.3644 11.8861C7.21188 15.2014 7.21188 20.5954 10.3644 23.9107L13.6141 27.3293L18.0373 31.9825C18.2307 32.186 18.5452 32.186 18.7386 31.9825L20.8426 29.7691C21.036 29.5656 21.036 29.2348 20.8426 29.0313L13.1697 20.9596C11.5646 19.2722 11.5646 16.5267 13.1697 14.8393C14.7737 13.1519 17.3845 13.1519 18.9886 14.8393L24 20.1154L29.0114 14.8393C30.6164 13.1519 33.2263 13.1519 34.8303 14.8393C36.4354 16.5267 36.4354 19.2722 34.8303 20.9596L21.5449 34.9336Z"
      fill="currentColor"
    />
  </svg>
);
